module.exports = __webpack_public_path__ + "media/images/icons/outlined/align-right-ca575cc8325f4bbb2cb1aef45b14d818.svg";